import { render, staticRenderFns } from "./ConstructionQualityManage.vue?vue&type=template&id=3b2883c1&scoped=true"
import script from "./ConstructionQualityManage.vue?vue&type=script&lang=js"
export * from "./ConstructionQualityManage.vue?vue&type=script&lang=js"
import style0 from "./ConstructionQualityManage.vue?vue&type=style&index=0&id=3b2883c1&prod&lang=less&scoped=true"
import style1 from "./ConstructionQualityManage.vue?vue&type=style&index=1&id=3b2883c1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2883c1",
  null
  
)

export default component.exports